module.exports = __webpack_public_path__ + "img/01.337e051d.jpg";